import { Link } from 'react-router-dom'

export default function CTA() {
    const handleLinkClick = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    
    return (
        <div className="mx-auto max-w-7xl py-4 sm:px-6 lg:px-8">
          <div className="relative isolate overflow-hidden px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-12" style={{ backgroundColor: "#3BC52B" }}>
            {/* Background Pattern */}
            <div className="absolute inset-0 bg-hero-pattern opacity-10"></div>
            
            {/* Content */}
            <div className="relative z-10">
              <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
                Company Overview
              </h2>
              <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-white/90">
                At ExecutiveHaven, We Believe Your Time Is Your Most Valuable Asset. We're Here To Help You Regain Control Of It, So You Can Focus On What Truly Matters For Your Business.
              </p>
              
              <div className="mt-10 flex items-center justify-center gap-x-6">
                <a
                  href="https://calendly.com/admin-executivehaven/discovery-call"
                  className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Get started
                </a>
                <Link to="/services" onClick={handleLinkClick} className="text-sm font-semibold leading-6 text-white hover:text-white/80">
                  Click here to view services <span aria-hidden="true">→</span>
                </Link>
              </div>
            </div>
            
            <svg
              viewBox="0 0 1024 1024"
              className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
              aria-hidden="true"
            >
              <circle cx={512} cy={512} r={512} fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)" fillOpacity="0.7" />
              <defs>
                <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
                  <stop stopColor="#7775D6" />
                  <stop offset={1} stopColor="#E935C1" />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>
    )
  }
  